import React from 'react';
import IconPlus from '../../assets/images/add.svg';

const CreateNewCaseButton = ({ onClick, disabled }) => (
  <div className="new-case">
    <button
      type="button"
      disabled={disabled}
      className={`btn--new-case ${disabled ? 'disabled' : ''}`}
      onClick={onClick}
    >
      <span className="icon-plus">
        <img src={IconPlus} className="icon-plus-img" alt="Create new case" />
      </span>
      New case
    </button>
  </div>
);

export default CreateNewCaseButton;
